//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "LayoutError",

  fetch: function () {
    this.$nextTick(() => {
      this.$meta().refresh();
    })
  },

  props: {
    error: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  head: function () {
    return {
      title: this.errorMessage
    }
  },

  computed: {
    errorMessage: function () {
      if (this.error?.statusCode === 404) {
        return 'Страница не найдена'
      }
      if (this.error?.statusCode === 401) {
        return 'Пользователь не авторизован'
      }
      return 'Что-то пошло не так!'
    }
  }
};
